<template lang="pug">
div
	Paragraph(:paragraph='paragraphs[0]')
	Paragraph(:paragraph='paragraphs[1]')
	Paragraph(:paragraph='paragraphs[2]')
	Paragraph(:paragraph='paragraphs[3]')
	div.mb-3 Very easy – we'll show you:
	div.d-sm-flex.justify-space-between.mb-6
		div(
			v-for='(step,i) in steps'
			:index='i'
			).mt-4.mt-sm-0
			ProcessStep(:step='step')
	Paragraph(:paragraph='paragraphs[4]')
</template>
<script>
import Paragraph from "../Elements/Paragraph.vue";
import ProcessStep from "../Elements/ProcessStep.vue";
export default {
	data() {
		return {
			steps: [
				{
					icon: "account_circle",
					text: "to your Account page",
					title: "Go",
					links: [{ text: "Go to Account", link: "/#/account" }]
				},
				{
					icon: "person_add",
					text: "Click ADD FRIENDS on the Purchase you need. Choose SPLIT",
					title: "Add Friends",
					links: []
				},
				{
					icon: "credit_score",
					text: "Follow instructions. We'll issue an Instant Refund",
					title: "Done",
					links: []
				}
			],
			paragraphs: [
				{
					title: "What is a Split?",
					text:
						"A Split lets you split the bill for the drinks you bought with your chip. It's very convenient for parties and getting beverages for friends."
				},
				{
					title: "When to Split?",
					text:
						"Whenever you buy drinks for yourself and your friend(s), and want them to contribute, a Split is the way to go."
				},
				{
					title: "How to respond to a Split?",
					text:
						"Go to your <a href='/#/account' style='text-decoration: underline'>Account</a>.\
						<ul style='padding-top: 4px'><li>On the desktop version, Split requests are listed at the top of the page</li>\
						<li>On mobile, click on Friends button in the bottom menu</li></ul> Click RESPOND and follow instructions"
				},
				{
					title: "How to Split a purchase?"
				},
				{
					title: `Can I Split with friends outside of ${
						this.isBiederDrinks ? "Biederstein" : "my dorm"
					}?`,
					text: "No. A " + this.$appTitle + " account is required for a Split."
				}
			]
		};
	},
	components: { ProcessStep, Paragraph }
};
</script>

<style scoped>
.step {
	position: absolute;
	top: 5px;
	left: 5px;
}
</style>
